





















































import { Individu } from "@/store/types";
import { Vue } from "vue-property-decorator";
import pointageCard from "./pointage-card.vue";
import pointageListHead from "./pointage-list-head.vue";

export default Vue.extend({
  props: {
    alphabet: {
      type: String,
    },
    enfants: {
      type: Array,
    },
    tempsAccueil: {
      type: Array,
    },
    pointageActif: {
      type: Array,
      default: () => [],
    },
    pointagesPrevi: {
      type: Array,
      default: () => [],
    },
    palettepresence: {
      type: Array,
      default: () => [],
    },
    paletteabsence: {
      type: Array,
      default: () => [],
    },
    listsupplements: {
      type: Array,
      default: () => [],
    },
    supplementsactifs: {
      type: Array,
      default: () => [],
    },
    tempsAccueilActif: {
      type: Array,
      default: () => [],
    },
    supplementsFiltreActifs: {
      type: Array,
      default: () => [],
    },
    currentActivite: {
      type: Number,
    },
    nbrIndividusPresents: {
      type: Number,
      default: () => 0,
    },
    listSupplementsPrevi: {
      type: Array,
      default: () => [],
    },
    currentEtablissement: {
      type: Object,
    },
    autori: {
      type: Number,
      default: -2,
    },
    nbrIndividusTotal: {
      type: Number,
      default: 999,
    },
    nbrIndividusFiltreesPresents: {
      type: Number,
      default: 0,
    },
  },
  components: {
    pointageCard,
    pointageListHead,
  },
  methods: {
    firstChar(str: string): string {
      return str.charAt(0).toLowerCase();
    },
    groupByLetters(letter: string) {
      let list: Array<Individu> = [];
      this.enfants.forEach((element: any) => {
        if (this.firstChar(element.displayName) === this.firstChar(letter)) {
          list.push(element);
        }
      });
      return list;
    },
    filtredSupplements() {
      return this.listsupplements.filter((supp: any) => {
        if (this.supplementsFiltreActifs.includes(supp.getId())) {
          return supp;
        }
      });
    },
  },
});
